<template>
  <div class="flex items-center justify-between px-4 py-1 sm:py-3">
    <img :src="require('@/images/logo.svg')" class="h-14 w-14" />
    <span v-if="mainStore.project && mainStore.project.name" class="truncate font-medium text-dark">
      <fa-icon type="far" icon="chevron-right" class="mx-4" />
      {{ mainStore.project.name }}
    </span>
    <div class="mx-2 grow"></div>

    <Providers />
    <CloseBtn class="ml-2 sm:ml-3 md:ml-6" />
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'
import CloseBtn from './CloseBtn.vue'
import Providers from './Providers.vue'

export default {
  components: {
    CloseBtn,
    Providers
  },
  computed: {
    ...mapStores(useMainStore)
  }
}
</script>
